;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import hash from 'object-hash';

import { localStorageSupport } from 'utils';

export const event = (eventName, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...data });
};

export const eventOnce = (eventName, data = {}) => {
    if (localStorageSupport()) {
        if (localStorage.getItem(`${eventName}-${hash(data)}`) === null) {
            event(eventName, data);
            localStorage.setItem(`${eventName}-${hash(data)}`, 'true');
        }
    } else {
        event(eventName, data);
    }
};

export const pageView = url => {
    event('pageview', { url });
};
